import { useTranslation } from "react-i18next";
import { Clock } from "lucide-react";
import { Badge, type BadgeVariantProps } from "@/shared/components/ui/badge";
import { getQueueTimeInfo, type QueueUrgency } from "./venue-queue-time";

const urgencyVariant: Record<QueueUrgency, NonNullable<BadgeVariantProps["variant"]>> = {
  green: "success",
  yellow: "warning",
  red: "danger",
  unknown: "outline",
};

interface VenueTimeBadgeProps {
  readonly venueId: string;
  readonly createdAt: string;
  readonly now?: Date;
}

export function VenueTimeBadge({ venueId, createdAt, now }: VenueTimeBadgeProps) {
  const { t } = useTranslation();
  const info = getQueueTimeInfo(createdAt, now);

  return (
    <Badge variant={urgencyVariant[info.urgency]} data-testid={`venue-time-badge-${venueId}`}>
      <Clock className="mr-1 h-3 w-3" />
      {t(info.labelKey, info.labelValues)}
    </Badge>
  );
}
